export * from "./Pokedex";
export { default } from "./Pokedex";